module.exports = __webpack_public_path__ + "static/media/concepts_for_artist_warehouse_studios_sign_2019.80376f35.webp";